import React from "react"
import useVisualClear from "../../hooks/useVisualClear"
import useWindowDimensions from "../../hooks/useWindowDimensions"
import getFooterHeight from "../../utils/getFooterHeight"
import { Agenda, AgendaContextProvider } from "../Agenda"
import Background from "../Background"
import BackToTop from "../BackToTop"
import Footer from "../Footer"
import MainHeader from "../MainHeader"
import { MainHeaders } from "../MainHeader/types/mainHeaders"
import Navigation from "../Navigation"
import ProgressBar from "../ProgressBar"

type Props = {
  agendaTitle?: string
  children: React.ReactNode
  isWithBackToTop?: boolean
  isWithAgenda?: boolean
  isWithProgressBar?: boolean
  isWithBackground?: boolean
  header: MainHeaders
  agendaHeight?: string
  isTurtleSmart?: boolean
  isPageLong?: boolean
}

const Layout = ({
  agendaTitle,
  children,
  isWithBackToTop = false,
  isWithAgenda = false,
  isWithProgressBar = false,
  isWithBackground = true,
  header,
  agendaHeight,
  isTurtleSmart = false,
  isPageLong,
}: Props) => {
  const { width } = useWindowDimensions()
  const footerHeight = getFooterHeight(width || 0)
  const isShown = useVisualClear(footerHeight)
  const renderChildren = () => (
    <AgendaContextProvider isWithAgenda={isWithAgenda}>
      <>{children}</>
    </AgendaContextProvider>
  )

  return (
    <>
      <Navigation />
      <MainHeader header={header} />
      <Background isShown={isWithBackground} isLong={isPageLong}>
        {renderChildren()}
        {isWithBackToTop && (
          <BackToTop isShown={isShown} isSmart={isTurtleSmart} />
        )}
        {isWithAgenda && (
          <Agenda
            title={agendaTitle || "Agenda title"}
            isShown={isShown}
            mobileHeight={agendaHeight}
          />
        )}
        {isWithProgressBar && (
          <ProgressBar isShown={isShown} footerHeight={footerHeight} />
        )}
      </Background>
      <Footer />
    </>
  )
}

export default Layout
